// Action Types
export const SET_LEADS = "outbound-calls/SET_LEADS";
export const UPDATE_LEAD_STATUS = "outbound-calls/UPDATE_LEAD_STATUS";
export const UPDATE_LEAD_TRANSCRIPT = "outbound-calls/UPDATE_LEAD_TRANSCRIPT";
export const ADD_TRANSCRIPT_MESSAGE = "outbound-calls/ADD_TRANSCRIPT_MESSAGE";
export const CLEAR_TRANSCRIPT_MESSAGES =
  "outbound-calls/CLEAR_TRANSCRIPT_MESSAGES";
export const SET_LOADING = "outbound-calls/SET_LOADING";

// Action Creators
export const setLeads = (leads) => ({
  type: SET_LEADS,
  payload: leads,
});

export const updateLeadStatus = (payload) => ({
  type: UPDATE_LEAD_STATUS,
  payload,
});

export const updateLeadTranscript = (payload) => ({
  type: UPDATE_LEAD_TRANSCRIPT,
  payload,
});

export const addTranscriptMessage = (payload) => ({
  type: ADD_TRANSCRIPT_MESSAGE,
  payload,
});

export const clearTranscriptMessages = (leadId) => ({
  type: CLEAR_TRANSCRIPT_MESSAGES,
  payload: leadId,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});
